import { FC } from "react";
import { Grid, GridItem } from "@chakra-ui/react";

import MachineAnalysisPreviewBlock from "./MachineAnalysisPreviewBlock";
import MachineAnalysisPreviewContent from "./MachineAnalysisPreviewContent";

type MachineAnalysisPreviewBlockInmateDataData = Partial<
  Record<
    | "firstName"
    | "usmNumber"
    | "lastName"
    | "middleName"
    | "suffix"
    | "race"
    | "sex"
    | "ethnicOrigin"
    | "dateOfBirth"
    | "total_offense_level"
    | "fbiNumber"
    | "ssn"
    | "stateOfBirth"
    | "countryOfBirth"
    | "citizenship"
    | "street"
    | "city"
    | "state"
    | "zip"
    | "foreignCountry"
    | "height"
    | "weight"
    | "hairColor"
    | "eyesColor"
    | "arsAssignment"
    | "offenseSentence",
    string | number | undefined
  >
>;

type MachineAnalysisPreviewBlockInmateDataProps = MachineAnalysisPreviewBlockInmateDataData & {
  title?: string;
};

const MachineAnalysisPreviewBlockInmateData: FC<MachineAnalysisPreviewBlockInmateDataProps> = ({ title, ...props }) => {
  return (
    <MachineAnalysisPreviewBlock title={title}>
      <Grid templateColumns="repeat(4, 1fr)" gap={3}>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="1. Register No." description={props.usmNumber} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="2. Last Name" description={props.lastName} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="3. First Name" description={props.firstName} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="4. Middle Name" description={props.middleName} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="5. Suffix" description={props.suffix} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="6. Race" description={props.race} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="7. Sex" description={props.sex} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="8. Ethnic Origin" description={props.ethnicOrigin} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="9. Date of Birth" description={props.dateOfBirth} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="10. Offence/Sentence" description={props.offenseSentence} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="11. FBI Number" description={props.fbiNumber} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="12. SSN Number" description={props.ssn} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="13. State of Birth" description={props.stateOfBirth} />
        </GridItem>
        <GridItem colSpan={2}>
          <MachineAnalysisPreviewContent title="14. Country of Birth" description={props.countryOfBirth} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="15. Citizenship" description={props.citizenship} />
        </GridItem>
        <GridItem colSpan={4}>
          <MachineAnalysisPreviewContent title="16. Address Street" description={props.street} />
        </GridItem>
        <GridItem colSpan={2}>
          <MachineAnalysisPreviewContent title="17. City" description={props.city} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="18. State" description={props.state} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="19. Zip" description={props.zip} />
        </GridItem>
        <GridItem colSpan={2}>
          <MachineAnalysisPreviewContent title="20. Foreign Country" description={props.foreignCountry} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="21. Height" description={props.height} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="22. Weight" description={props.weight} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="23. Hair Color" description={props.hairColor} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="24. Eyes Color" description={props.eyesColor} />
        </GridItem>
        <GridItem colSpan={1}>
          <MachineAnalysisPreviewContent title="25. ARS Assignment" description={props.arsAssignment} />
        </GridItem>
      </Grid>
    </MachineAnalysisPreviewBlock>
  );
};

export default MachineAnalysisPreviewBlockInmateData;
